const reconnectListeners = new Set<() => void>();
let hasEstablishedConnection = false;

/**
 * graphql-ws calls `connected` on the first handshake and on every reconnect.
 * Skip the first so mount-time claim/subscribe is not doubled.
 */
export const notifyGraphQLWsConnected = () => {
  if (!hasEstablishedConnection) {
    hasEstablishedConnection = true;
    return;
  }

  reconnectListeners.forEach((listener) => {
    listener();
  });
};

export const subscribeToGraphQLWsReconnect = (listener: () => void) => {
  reconnectListeners.add(listener);

  return () => {
    reconnectListeners.delete(listener);
  };
};
